var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-notice-bar',{attrs:{"left-icon":"volume-o","text":"在代码阅读过程中人们说脏话的频率是衡量代码质量的唯一标准。"}}),_c('van-field',{attrs:{"label":"文本","placeholder":"请输入用户名"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }